import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faChartBar,
  faBell,
  faRightFromBracket,
  faBriefcase,
  faCakeCandles,
  faCalendarDays,
  faCalendar,
  faCalendarMinus,
  faCalendarWeek,
  faCalendarXmark,
  faCalendarCheck,
  faCamera,
  faCommentDots,
  faCheck,
  faCircleCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboard,
  faClock,
  faDownload,
  faEnvelope,
  faCircleExclamation,
  faTriangleExclamation,
  faEye,
  faFileLines,
  faFolder,
  faLocationDot,
  faGift,
  faTableColumns,
  faHeadset,
  faHouse,
  faImage,
  faInbox,
  faInfinity,
  faCircleInfo,
  faBolt,
  faBars,
  faPalette,
  faPencil,
  faPenToSquare,
  faUsers,
  faIdBadge,
  faCircleUser,
  faUserSlash,
  faUserPlus,
  faPlus,
  faCircleQuestion,
  faMagnifyingGlass,
  faShieldHalved,
  faSliders,
  faStar,
  faPhone,
  faEllipsisVertical,
  faTrash,
  faUpload,
  faXmark,
  faCircleXmark,
  faPersonCircleXmark,
  faTableList,
  faClockRotateLeft,
  faHandshake,
  faFileContract,
  faCertificate,
  faAward,
  faUserTie,
  faBuilding,
  faLock,
  faUnlock,
  faPaperclip,
  faBan,
  faRotateLeft,
  faEllipsis,
  faTag,
} from "@fortawesome/free-solid-svg-icons";

const ICON_MAP = {
  "arrow-left": faArrowLeft,
  "bar-chart-fill": faChartBar,
  bell: faBell,
  "box-arrow-right": faRightFromBracket,
  briefcase: faBriefcase,
  cake2: faCakeCandles,
  "calendar-event": faCalendarDays,
  "calendar-heart": faCalendar,
  "calendar-minus": faCalendarMinus,
  "calendar-week": faCalendarWeek,
  "calendar-x": faCalendarXmark,
  "calendar2-check": faCalendarCheck,
  "calendar2-heart": faCalendar,
  "calendar2-week": faCalendarWeek,
  calendar3: faCalendar,
  "camera-fill": faCamera,
  camera: faCamera,
  "chat-heart": faCommentDots,
  check: faCheck,
  "check-circle": faCircleCheck,
  "check-circle-fill": faCircleCheck,
  "chevron-down": faChevronDown,
  "chevron-left": faChevronLeft,
  "chevron-right": faChevronRight,
  "chevron-up": faChevronUp,
  "clipboard2-data": faClipboard,
  "clock-fill": faClock,
  clock: faClock,
  download: faDownload,
  envelope: faEnvelope,
  "exclamation-circle": faCircleExclamation,
  "exclamation-triangle": faTriangleExclamation,
  "exclamation-triangle-fill": faTriangleExclamation,
  eye: faEye,
  "eye-fill": faEye,
  "file-earmark-text": faFileLines,
  folder2: faFolder,
  "geo-alt": faLocationDot,
  gift: faGift,
  "grid-1x2": faTableColumns,
  headset: faHeadset,
  house: faHouse,
  image: faImage,
  inbox: faInbox,
  infinity: faInfinity,
  "info-circle": faCircleInfo,
  "info-circle-fill": faCircleInfo,
  "lightning-charge-fill": faBolt,
  list: faBars,
  palette: faPalette,
  pencil: faPencil,
  "pencil-square": faPenToSquare,
  people: faUsers,
  "people-fill": faUsers,
  "person-badge": faIdBadge,
  "person-circle": faCircleUser,
  "person-fill-slash": faUserSlash,
  "person-plus-fill": faUserPlus,
  plus: faPlus,
  "plus-lg": faPlus,
  "question-circle": faCircleQuestion,
  search: faMagnifyingGlass,
  "shield-exclamation": faShieldHalved,
  "shield-check": faShieldHalved,
  sliders: faSliders,
  stars: faStar,
  star: faStar,
  telephone: faPhone,
  "three-dots-vertical": faEllipsisVertical,
  trash: faTrash,
  trash3: faTrash,
  upload: faUpload,
  x: faXmark,
  "x-circle": faCircleXmark,
  "x-circle-fill": faCircleXmark,
  "x-lg": faXmark,
  "person-fill-x": faPersonCircleXmark,
  "table-list": faTableList,
  "clock-history": faClockRotateLeft,
  handshake: faHandshake,
  "file-contract": faFileContract,
  certificate: faCertificate,
  award: faAward,
  "person-workspace": faUserTie,
  building: faBuilding,
  lock: faLock,
  unlock: faUnlock,
  paperclip: faPaperclip,
  ban: faBan,
  "arrow-counterclockwise": faRotateLeft,
  "three-dots": faEllipsis,
  tag: faTag,
};

/**
 * Universal icon component. Accepts Bootstrap Icons name (with or without "bi-" prefix).
 * Renders a Font Awesome SVG icon.
 *
 * @param {string} name  - icon name e.g. "camera-fill", "bi-bell", "arrow-left"
 * @param {string} className - extra CSS classes (Bootstrap utility classes work)
 * @param {object} style - inline styles
 */
const Icon = ({ name, className, style, ...rest }) => {
  const key = name?.replace(/^bi-/, "");
  const icon = ICON_MAP[key];
  if (!icon) return null;
  return (
    <FontAwesomeIcon
      icon={icon}
      className={className || undefined}
      style={style}
      {...rest}
    />
  );
};

export default Icon;
